import { IgTypography } from "@intelligems/ig-theme";
import { Skeleton, Stack } from "@mui/material";

import { formatMetricValue } from "../shared/utils/mobileAnalyticsFormatters";

import { BaseRendererProps } from "./types";

export const P2bbRenderer = ({
  variantData,
  isLoading,
  currency,
}: BaseRendererProps) => {
  return (
    <Stack spacing={10} sx={{ paddingY: 5 }}>
      {variantData.map((variant) => (
        <Stack
          key={variant.variation_id}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <IgTypography>{variant.name}</IgTypography>
          {isLoading ? (
            <Skeleton variant="rectangular" width={60} height={24} />
          ) : (
            <IgTypography fontSize={17} fontWeight={600}>
              {formatMetricValue(variant.p2bb, "percentNoDecimal", currency)}
            </IgTypography>
          )}
        </Stack>
      ))}
    </Stack>
  );
};
